<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .student -->
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('master.student')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="student"
                  vid="student"
                  rules="required"
                >
                  <b-form-select
                    v-model="student"
                    :options="students"
                    text-field="name"
                    value-field="id"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('master.student')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .type -->
            <b-col lg="6">
              <b-form-group
                id="input-group-2"
                :label="$t('master.type')"
                label-for="input-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="type"
                  vid="type"
                  rules="required"
                >
                  <b-form-select
                    v-model="type"
                    :options="types"
                    text-field="name"
                    value-field="id"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('master.type')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .body -->
            <b-col lg="6">
              <b-form-group
                id="input-group-3"
                :label="$t('master.body')"
                label-for="input-3"
              >
                <validation-provider
                  #default="{ errors }"
                  name="body"
                  vid="body"
                  rules="required"
                >
                  <b-form-input
                    id="input-3"
                    v-model="newItem.body"
                    type="text"
                    :placeholder="$t('master.body')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .editable -->
            <b-col lg="6">
              <b-form-group
                id="input-group-4"
                :label="$t('master.editable')"
                label-for="input-4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="editable"
                  vid="editable"
                  rules="required"
                >
                  <b-form-input
                    id="input-4"
                    v-model="newItem.editable"
                    type="text"
                    :placeholder="$t('master.editable')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .start_date -->
            <b-col lg="6">
              <b-form-group
                id="input-group-5"
                :label="$t('master.start_date')"
                label-for="input-5"
              >
                <validation-provider
                  #default="{ errors }"
                  name="start_date"
                  vid="start_date"
                  rules="required"
                >
                  <b-form-input
                    id="input-5"
                    v-model="newItem.start_date"
                    type="text"
                    :placeholder="$t('master.start_date')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .title -->
            <b-col lg="6">
              <b-form-group
                id="input-group-6"
                :label="$t('master.title')"
                label-for="input-6"
              >
                <validation-provider
                  #default="{ errors }"
                  name="title"
                  vid="title"
                  rules="required"
                >
                  <b-form-input
                    id="input-6"
                    v-model="newItem.title"
                    type="text"
                    :placeholder="$t('master.title')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .status -->
            <b-col lg="6">
              <b-form-group
                id="input-group-7"
                :label="$t('master.status')"
                label-for="input-7"
              >
                <validation-provider
                  #default="{ errors }"
                  name="status"
                  vid="status"
                  rules="required"
                >
                  <b-form-select
                    v-model="status"
                    :options="statuss"
                    text-field="name"
                    value-field="id"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('master.status')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .thesisFile -->
            <b-col lg="6">
              <b-form-group
                id="input-group-8"
                :label="$t('master.thesisFile')"
                label-for="input-8"
              >
                <validation-provider
                  #default="{ errors }"
                  name="thesisFile"
                  vid="thesisFile"
                  rules="required"
                >
                  <b-form-input
                    id="input-8"
                    v-model="newItem.thesisFile"
                    type="text"
                    :placeholder="$t('master.thesisFile')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .plan -->
            <b-col lg="6">
              <b-form-group
                id="input-group-9"
                :label="$t('master.plan')"
                label-for="input-9"
              >
                <validation-provider
                  #default="{ errors }"
                  name="plan"
                  vid="plan"
                  rules="required"
                >
                  <b-form-input
                    id="input-9"
                    v-model="newItem.plan"
                    type="text"
                    :placeholder="$t('master.plan')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .planFile -->
            <b-col lg="6">
              <b-form-group
                id="input-group-10"
                :label="$t('master.planFile')"
                label-for="input-10"
              >
                <validation-provider
                  #default="{ errors }"
                  name="planFile"
                  vid="planFile"
                  rules="required"
                >
                  <b-form-input
                    id="input-10"
                    v-model="newItem.planFile"
                    type="text"
                    :placeholder="$t('master.planFile')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .masterFile -->
            <b-col lg="6">
              <b-form-group
                id="input-group-11"
                :label="$t('master.masterFile')"
                label-for="input-11"
              >
                <validation-provider
                  #default="{ errors }"
                  name="masterFile"
                  vid="masterFile"
                  rules="required"
                >
                  <b-form-input
                    id="input-11"
                    v-model="newItem.masterFile"
                    type="text"
                    :placeholder="$t('master.masterFile')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/MastersController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
  name: "MastersForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  data() {
    return {
      file: {},
      
      student: [],
      type: [],
      status: [],
    };
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
  },
};
</script>

